module.exports = __webpack_public_path__ + "img/22.6f0cc764.png";